import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
// this redirect is needed because we supported /job/:id when developing v2
export const JobPageRedirect = ({ isAdmin = false }) => {
    const { id } = useParams();
    return (React.createElement(Navigate, { replace: true, to: `/${isAdmin ? 'admin' : 'account'}/jobs/${id}` }));
};
